module.exports = __webpack_public_path__ + "img/floorplan_citationX.3b37a357.png";